import type { AnySchema } from 'yup';

/**
 * Whether the stepper header can jump from `currentStep` to `targetStep`.
 *
 * Going back is always allowed (same as Back). Going forward is allowed only
 * when every step between the current one and the target passes the
 * step-conditional schema — the same gate Next uses, without skipping holes.
 */
export const canNavigateToStep = (
  targetStep: number,
  currentStep: number,
  values: unknown,
  schema: AnySchema,
): boolean => {
  if (targetStep === currentStep || targetStep < 0) return false;
  if (targetStep < currentStep) return true;

  const formValues =
    values && typeof values === 'object' ? (values as Record<string, unknown>) : {};

  for (let step = currentStep; step < targetStep; step += 1) {
    if (!schema.isValidSync({ ...formValues, currentStep: step })) return false;
  }

  return true;
};
